<div class="generating-labels-batch">
  <div class="generating-labels-batch__name">
    <span class="generating-labels-batch__name--value">{{ batch.name }}</span>
    @if (isTplCarrier) {
      <div>
        <app-3pl-tag [height]="'14px'" [width]="'23px'" [text]="'3PL'"> </app-3pl-tag>
      </div>
    }
  </div>
  <div class="generating-labels-batch__process">
    {{ getGeneratingLabelsText() }} ({{ batch.succeeded + batch.failed }}/{{ batch.total }})...
  </div>
  <pdq-progress-bar mode="indeterminate" size="small" borderRadius="none"></pdq-progress-bar>
</div>
